import React from 'react';

import { BaseDialog } from '@metarouter-private/mr-mui';

import useConfirmDeployModalProps from './useConfirmDeployModalProps';
import ConfirmDeployContent from './ConfirmDeployContent';
import ConfirmDeployActions from './ConfirmDeployActions';

export default function ConfirmDeployModal() {
  const { DialogProps, selectedCount, onClose, onConfirm, setConfirmInputValue, confirmDisabled } =
    useConfirmDeployModalProps();

  return (
    <BaseDialog
      DialogProps={DialogProps}
      title="Confirm Deployment"
      content={<ConfirmDeployContent selectedCount={selectedCount} onConfirmInputChange={setConfirmInputValue} />}
      actions={<ConfirmDeployActions disabled={confirmDisabled} onConfirm={onConfirm} onCancel={onClose} />}
      data-test-id="confirmDeployModal"
    />
  );
}
